// const breakpoints = {
//   oversize: 1500,
//   desktop: 1200,
//   ipadpro: 992,
//   ipad: 768,
//   mobileXL: 650,
//   mobileL: 425,
//   mobileM: 375,
//   mobile: 320,
// };
interface BreakType {
  [key: string]: number;
}
const breakpoints = {
  md: 991.98,
  lg: 1279.98,
};
const MediaQuery = (name: string) => {
  const arr = Object.keys(breakpoints).map((key) => [
    key,
    (breakpoints as BreakType)[key],
  ]);
  const [media] = arr.reduce((acc, [key, index]) => {
    if (name === key) return [...acc, `@media (max-width: ${index}px)`];
    return acc;
  }, []);
  return media;
};

export default MediaQuery;
